import * as Sentry from '@sentry/react';
import environment from '@/environment';
import { AuthResult } from '@/schemas/clientInitSchema';
import { datadogRum } from '@datadog/browser-rum';
import sessionId from './session-service';

interface ReportError {
  error: unknown;
}
interface ReportMessage {
  message: string;
}

export function trackUser({ quote_id, partner }: AuthResult) {
  const id = sessionId();

  Sentry.setUser({
    id: id,
    quoteId: quote_id,
  });

  Sentry.setExtra('partner', partner);

  datadogRum.setUser({
    id: id,
    quoteId: quote_id,
    partner: partner,
  });
}

export function reportError({ error }: ReportError) {
  if (environment.environment !== 'production') {
    console.error(error);
  }

  Sentry.withScope((scope) => {
    scope.setTag('team', 'onboarding_team');

    Sentry.captureException(error);
  });
}

export function reportMessage({ message }: ReportMessage) {
  if (environment.environment !== 'production') {
    console.error(message);
  }

  Sentry.withScope((scope) => {
    scope.setTag('team', 'onboarding_team');

    Sentry.captureMessage(message);
  });
}
